'use strict';

/**
 * DynamicPages
 *
 * @type {{add: waApp.controllers.DynamicPages.add, edit: waApp.controllers.DynamicPages.edit}}
 */
waApp.controllers.DynamicPages = {
	add: function() {
		waUtils.inputLanguageToggle();
		waUtils.initCkEditor({
			toolbar: 'Cms',
			allowedContent: true,
			extraAllowedContent: 'span(*)'
		});
	},
	edit: function() {
		waUtils.inputLanguageToggle();
		waUtils.initCkEditor({
			toolbar: 'Cms',
			allowedContent: true,
			extraAllowedContent: 'span'
		});
	}
};
